import { render, staticRenderFns } from "./supplierInformation.vue?vue&type=template&id=2f7eaaf0&scoped=true"
import script from "./supplierInformation.vue?vue&type=script&lang=js"
export * from "./supplierInformation.vue?vue&type=script&lang=js"
import style0 from "./supplierInformation.vue?vue&type=style&index=0&id=2f7eaaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7eaaf0",
  null
  
)

export default component.exports